/**
 * Low shrubs scattered over the town (lifted from lantern-water's `world.js`
 * `createTown` and `shrub`): `count` tries at random points of the town
 * (x -19..20, z -17..17 in three.js axes), skipping the canal (x 3..11) and
 * the open plaza (x -14..1, z -5..9); each shrub is three tilted leaf cards
 * on the ground of its district (2.4 on the western terrace and 3.36 on the
 * eastern north of the terrace front z -4.8, else 0). Placed at the origin
 * (the points are the town's). Its own random stream: the shrubs fall where
 * the prototype's rule puts them, not on the prototype's very spots.
 *
 * Params: `count` (40).
 */
import * as THREE from 'three';
import { num } from '../kit.ts';
import type { Prefab } from './types.ts';

/** The district's ground height (`terrain.js` `districtHeight`). */
export const districtHeight = (x: number, z: number): number => (z < -4.8 ? (x < 7 ? 2.4 : 3.36) : 0);

export const prefab: Prefab = {
  id: 'shrub_scatter',
  buildPrefab(ctx) {
    const root = new THREE.Group();
    const { mesh, random, plane, leafMats } = ctx;
    const count = num(ctx, 'count', 40);
    for (let i = 0; i < count; i += 1) {
      const x = -19 + random() * 39;
      const z = -17 + random() * 34;
      if ((x > 3 && x < 11) || (x > -14 && x < 1 && z > -5 && z < 9)) continue;
      const s = 0.45 + random() * 0.5;
      const y0 = districtHeight(x, z);
      for (let k = 0; k < 3; k += 1) {
        const o = mesh(root, plane, leafMats[0], x + (random() - 0.5) * s, y0 + 0.4 + s * 0.2, z + (random() - 0.5) * s, s * 1.5, s, 1);
        o.rotation.x = -0.25;
      }
    }
    return { root };
  },
};
